import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTags } from '@fortawesome/free-solid-svg-icons'
import { CurrencyFormat, DateFormat } from "../../../../helpers/formatting"

export default function LoanSummary({ customerData, loanSummary }) {
  const loanAgreementData = loanSummary;
    const formatItemValue = (type, val) => {
        try {
            switch (type) {
                case 'date':
                    return DateFormat({ dateString: val.includes(' ') ? val.split(' ')[0] : val });
                case 'currencyLong':
                    return CurrencyFormat({ value: val, showCurrencySign: true, showCents: true });
                case 'currencyShort':
                  return CurrencyFormat({ value: val, showCurrencySign: true, showCents: false });
                default:
                    return val;
            }
        } catch (e) {
            return val;
        }
    };

    // Build main loan summary items
    const loanSummaryItems = [
      { label: 'Loan Number', value: formatItemValue('string', loanAgreementData.loan_number) },
      { label: 'Borrower', value: formatItemValue('string', loanAgreementData.borrower) },
      { label: 'Borrower Address', value: formatItemValue('string', loanAgreementData.borrower_address) },
      { label: 'Loan Effective Date', value: formatItemValue('date', loanAgreementData.effective_date) },
      { label: 'Loan Agreement Date', value: formatItemValue('date', loanAgreementData.loan_agreement_date) },
    ];

    // Add refinanced loan fields if they exist
    if (loanAgreementData?.refinancedLoan) {
      loanSummaryItems.push({
        label: 'Amount Paid to your Previous Loan',
        value: formatItemValue('currencyLong', loanAgreementData.refinancedLoan.paidOffPrincipal || 0)
      });
      loanSummaryItems.push({
        label: 'Amount Given to you Directly',
        value: formatItemValue('currencyLong', loanAgreementData.refinancedLoan.directCash || 0)
      });
    }

    // Add principal amount
    loanSummaryItems.push({
      label: 'Total Loan Principal',
      value: formatItemValue('currencyShort', loanAgreementData.principal_amount)
    });

    // Build payment items
    const paymentItems = [
      { label: 'Payment Amount:', value: formatItemValue('currencyLong', loanAgreementData.regular_payment_amount) },
      { label: 'Number of Payments:', value: formatItemValue('string', loanAgreementData.number_of_payments) },
    ];

    const appliedPromotionCode = loanSummary.promotion?.code || '';

    const bankingInfoItems = [
        {
            label: 'Bank Name',
            value: customerData.bank_name_label || '—',
        },
        {
            label: 'Account Number',
            value: customerData.bank_account_number || '—',
        },
        {
            label: 'Routing',
            value: customerData.bank_routing_number || '—',
        },
    ]

    return (
        <div className="loan-summary-card">
            <div className="loan-summary-card__heading py-3">
                <p className="loan-summary-card__heading-text">Loan Summary</p>
                {!!appliedPromotionCode && (
                    <div className="applied-promo-indicator">
                        <span className="icon">
                          <FontAwesomeIcon className="is-small applied-promo-indicator__icon" icon={faTags} />
                        </span>
                        <span className="applied-promo-indicator__code">{appliedPromotionCode}</span> applied
                    </div>
                )}
            </div>
            {!!loanSummaryItems.length && (
                <ul className="loan-summary-card__list">
                  {loanSummaryItems.map((item) => {
                    return (
                      <li className="loan-summary-card__item" key={item.label}>
                        {item.label}
                        <span>{item.value}</span>
                      </li>
                    )
                  })}
                </ul>
            )}
          {!!paymentItems.length && (
            <ul className="loan-summary-card__list">
              {paymentItems.map((item) => {
                        return (
                            <li className="loan-summary-card__item" key={item.label}>
                                {item.label}
                                <span>{item.value}</span>
                            </li>
                        )
                    })}
                </ul>
            )}
          {!!bankingInfoItems.length && (
            <ul className="loan-summary-card__list">
              {bankingInfoItems.map((item) => {
                return (
                  <li className="loan-summary-card__item pii-surfly-hide" key={item.label}>
                    {item.label}
                    <span>{item.value}</span>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
    )
}
